var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.0000455px",
    height: "20.0013482px",
    viewBox: "0 0 20.0000455 20.0013482",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connexion",
    transform: "translate(-1319.999970, -433.987651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1318.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.3,
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,12 L16,13.5 C16,14.8807119 17.1192881,16 18.5,16 C19.8807119,16 21.0000075,14.8807119 21.0000075,13.5 L21.0000075,12 C21.0051027,8.02907429 18.4071572,4.5240723 14.6063889,3.37409942 C10.8056207,2.22412655 6.70034838,3.70098106 4.50320764,7.00867657 C2.3060669,10.3163721 2.53635607,14.6731285 5.06995524,17.7307669 C7.60355441,20.7884052 11.8416426,21.8242469 15.5,20.28",
    id: "Path",
    strokeOpacity: 0.3,
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtGrey);
export default __webpack_public_path__ + "static/media/icon_at_grey.a00839d6af64c898360ae3328ef0f228.svg";
export { ForwardRef as ReactComponent };